import React, { useEffect, useState } from 'react';

import { Slot, Line, Slider } from './index.style';

/**
 * The space under a section's heading where a thin sliding line says "this section is still loading".
 *
 * THE SPACE IS ALWAYS THERE. It is the same height whether or not the line is showing, so the line appearing and
 * disappearing never moves anything below it. (It used to be added and removed with the line, and the page jumped when
 * the data arrived.)
 *
 * THE LINE ITSELF waits SHOW_AFTER_MS after `active` becomes true, so a call that answers quickly never flashes an
 * indicator. It shows no percentage and no seconds: the calls report no progress, and counting seconds draws attention
 * to how slow the wait is.
 */
const SHOW_AFTER_MS = 2000;

interface SectionLoadingLineProps {
  // True while the section's call is still running.
  active: boolean;
}

const SectionLoadingLine: React.FC<SectionLoadingLineProps> = ({ active }): React.ReactElement => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!active) {
      setVisible(false);
      return undefined;
    }

    const timer = window.setTimeout(() => setVisible(true), SHOW_AFTER_MS);

    return () => window.clearTimeout(timer);
  }, [active]);

  return (
    <Slot>
      {visible && (
        <Line role="status" aria-live="polite" aria-label="Loading">
          <Slider />
        </Line>
      )}
    </Slot>
  );
};

export default SectionLoadingLine;
